import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CheckboxSelected = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CheckboxSelected' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,2 L22,2 L22,22 L2,22 L2,2 Z M5,13 L10,17 L19,6' />
  </StyledIcon>
);
